import { Route } from "react-router";

const LoginPaths = {
    Login: "login",
    ResetPassword: "reset-password",
} as const;

export const LoginRoutes = {
    LOGIN: `/${LoginPaths.Login}`,
    RESET_PASSWORD: `/${LoginPaths.ResetPassword}`,
} as const;

export const loginRoutes = (
    <Route>
        <Route
            path={LoginPaths.Login}
            lazy={async () => {
                const { LoginPage } =
                    await import("@authentication/presentation/pages/login/login.page");
                return { Component: LoginPage };
            }}
        />
        <Route
            path={LoginPaths.ResetPassword}
            lazy={async () => {
                const { ResetPassword } =
                    await import("@authentication/presentation/pages/login/reset-password.page");
                return { Component: ResetPassword };
            }}
        />
    </Route>
);
